import { MergeStep, MergeUserPreview } from './types';

export const STEP_LABELS: MergeStep[] = [
  'TOPOLOGY',
  'USERS',
  'STORAGE',
  'COMMUNICATION',
];

export const roleColorMap: Record<MergeUserPreview['finalRole'], string> = {
  SUPER_ADMIN: 'red.400',
  ADMIN: 'blue.400',
  SUPPORT: 'purple.400',
  BASIC: 'gray.600',
};
